bq.updateAccountingBudgets = function () {
    var budgets = {};
    $('[data-bq="accounting-budget"]').each(function () {
        var type = $(this).data('budget-type');
        if (!budgets[type]) {
            budgets[type] = {};
        }
        var currency = $(this).data('budget-currency');
        if (!budgets[type][currency]) {
            budgets[type][currency] = [];
        }
        var id = $(this).data('budget-id');
        if (budgets[type][currency].indexOf(id) == -1) {
            budgets[type][currency].push(id);
        }
    });
    $.getJSON(bq.urls.ajax.accountingBudgets, {'budgets':budgets}, bq.setAccountingBudgets);
};

bq.setAccountingBudgets = function (budgets) {
    var $budgets = $('[data-bq="accounting-budget"]');
    $budgets.each(function () {
        var $budget = $(this),
            budgetId = $budget.data('budget-id'),
            budgetType = $budget.data('budget-type'),
            budgetCurrency = $budget.data('budget-currency'),
            budgetName = bq.helper.escapeHtml($budget.data('budget-name')),
            budgetNameRegEx = new RegExp('{{budget_name}}', 'g'),
            budgetBox = '';

        var data = {};
        if (typeof budgets[budgetType] !== 'undefined' && budgets[budgetType][budgetCurrency] !== 'undefined') {
            data = budgets[budgetType][budgetCurrency];
        }

        if (budgetId && typeof data[budgetId] !== 'undefined') {
            budgetBox = data[budgetId];
        } else if (typeof data[0] !== 'undefined') {
            budgetBox = data[0];
        }
        if (budgetBox != '') {
            budgetBox = budgetBox
              .replace(budgetNameRegEx, budgetName);
        }
        $budget.html(budgetBox);
    });
};

if ($('[data-bq="accounting-budget"]').length) {
    bq.updateAccountingBudgets();
}
